import { createContext, useContext, useState, useCallback } from 'react';

const ATSContext = createContext();

export const useATS = () => {
  const context = useContext(ATSContext);
  if (!context) {
    throw new Error('useATS must be used within an ATSProvider');
  }
  return context;
};

export const ATSProvider = ({ children }) => {
  const [resumeText, setResumeText] = useState('');
  const [jobDescription, setJobDescription] = useState('');
  const [experienceLevel, setExperienceLevel] = useState('entry');
  const [scoreResults, setScoreResults] = useState(null);
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const [uploadedFileName, setUploadedFileName] = useState('');

  const clearResults = useCallback(() => {
    setResumeText('');
    setJobDescription('');
    setExperienceLevel('entry');
    setScoreResults(null);
    setUploadedFileName('');
  }, []);

  const value = {
    resumeText,
    setResumeText,
    jobDescription,
    setJobDescription,
    experienceLevel,
    setExperienceLevel,
    scoreResults,
    setScoreResults,
    isAnalyzing,
    setIsAnalyzing,
    uploadedFileName,
    setUploadedFileName,
    clearResults,
  };

  return (
    <ATSContext.Provider value={value}>
      {children}
    </ATSContext.Provider>
  );
}; 